<script setup>
import { computed } from "vue";
import { useUiStore } from '@/store/uiStore'
import SidenavList from "./SidenavList.vue";

const ui = useUiStore()
const isRTL = computed(() => ui.isRTL);
const layout = computed(() => ui.layout);
const sidebarType = computed(() => ui.sidebarType);
const darkMode = computed(() => ui.darkMode);

const minimizeSidebar = () => ui.sidebarMinimize();


</script>
<template>
  <!-- <div v-show="layout === 'default'" class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-transparent' : 'bg-success'}`" /> -->
  <div v-show="layout === 'default'" class="min-height-300 position-absolute w-100"
    :style="!darkMode ? 'background-image: url(images/fondo-empresa1.png); background-size: cover; background-position: center;' : ''" />


  <aside class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl" :class="`${isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'}    
      ${layout === 'landing' ? 'bg-transparent shadow-none' : ' '
    } ${sidebarType}`" id="sidenav-main">
    <div class="sidenav-header d-flex align-items-center justify-content-center position-relative">
      <!-- Icono cerrar para mobile (ya existente) -->
      <i class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true" id="iconSidenav"></i>

      <router-link class="m-0 navbar-brand p-1" to="/">
        <img :src="darkMode || sidebarType === 'bg-default' ? 'images/logo.png' : 'images/logo.png'"
          class="navbar-brand-img h-100" alt="main_logo" />
        <!-- <span class="ms-2 font-weight-bold me-2">Dashboard</span> -->
      </router-link>
      <!-- Icono cerrar alineado a la derecha -->
      <a href="#" class="p-0 nav-link text-dark position-absolute end-4 top-50 translate-middle-y" style="z-index:2;"
        @click="minimizeSidebar" id="iconNavbarSidenav2">
        <font-awesome-icon icon="fa-solid fa-circle-xmark" />
      </a>
    </div>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list />
  </aside>
</template>
